const {Component} = require("react");
//const InputMask = require("inputmask");
const IMask = require("imask/dist/imask");
const env = require("app/services/env");

class Price extends Component {

	componentDidMount() {
		/*(new InputMask("numeric", {
			suffix: ",-",
			groupSeparator: ".",
			radixPoint: ",",
			placeholder: "0",
			autoGroup: true,
			digits: 0,
			digitsOptional: true,
			clearMaskOnLostFocus: false

		})).mask(this.inputElement);*/

		this.inputMask = new IMask(this.inputElement, {
			mask: Number,
			scale: 0,
			thousandsSeparator: this.thousandSeparator,
		});
	}

    get thousandSeparator() {
      return env.get('currency.thousand_separator');
    }

	get value() {
		return this.inputElement.value;
	}

	set value(value) {
		this.inputElement.value = value;

		if (this.inputMask) {
			this.inputMask.updateValue();
			this.inputMask.updateControl();
		}
	}

	get numericValue() {
		const value = this.value;

		return parseFloat(
			value
			//.substr(0, value.length - 2)
				.replace(this.thousandSeparator, "")
				.replace(",", ".")
		);
	}

	get element() {
		return this.inputElement;
	}

	render() {

      let pattern = "[\\d" + this.thousandSeparator + "]*";

		return (
			<div className="price-field">
				<input ref={el => this.inputElement = el} type="text" pattern={pattern} {...this.props} />
				<span className="text-placeholder"></span>
			</div>
		);
	}

}

module.exports = Price;
